exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "iframe{border:1px solid #e2f0f9;max-width:100%}", ""]);

// exports
